import { render, staticRenderFns } from "./microBlogs.vue?vue&type=template&id=243c6b69"
import script from "./microBlogs.vue?vue&type=script&lang=js"
export * from "./microBlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports